export default __webpack_public_path__ + "static/media/garden2.b2cd0baf.png";